import { useGetArtistProfileQuery } from '../../../../redux/api/fymAPI';
import { useRealtimePollInterval } from '../../../realtime/useRealtimePollInterval';
import { profileIsBusy } from './profileSlots';

/** While a profile image is made or sent and the socket is down, the page reads the profile again every 10 s. */
export const PROFILE_POLL_MS = 10_000;

/**
 * The profile of the artist (`GET /accounts/:accountId/artist-profile`). It polls only while a
 * version is queued, rendering or sending AND the socket is down: with the socket up, the event
 * `profile.asset.updated` reads the data again (`realtimeEventTags.ts`).
 */
export function useProfileData(accountId: number) {
  const query = useGetArtistProfileQuery({ accountId });
  const pollingInterval = useRealtimePollInterval(profileIsBusy(query.data?.assets) ? PROFILE_POLL_MS : 0);
  // A second subscription that only polls: the first one keeps the cache entry while nothing works.
  useGetArtistProfileQuery({ accountId }, { skip: pollingInterval === 0, pollingInterval });
  return query;
}
